import { render, staticRenderFns } from "./senderInfo.vue?vue&type=template&id=e8f9e0ea&scoped=true"
import script from "./senderInfo.vue?vue&type=script&lang=js"
export * from "./senderInfo.vue?vue&type=script&lang=js"
import style0 from "./senderInfo.vue?vue&type=style&index=0&id=e8f9e0ea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f9e0ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8f9e0ea')) {
      api.createRecord('e8f9e0ea', component.options)
    } else {
      api.reload('e8f9e0ea', component.options)
    }
    module.hot.accept("./senderInfo.vue?vue&type=template&id=e8f9e0ea&scoped=true", function () {
      api.rerender('e8f9e0ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/logisticsOrders/components/detailBox/components/senderInfo.vue"
export default component.exports